<template>
    <div class="audit-flow">
        <div class="audit-flow-title" v-if="timeLineList && timeLineList.length">审批流程</div>
        <div class="audit-timeline" v-if="timeLineList && timeLineList.length">
            <div class="audit-item" v-for="(item, index) in timeLineList" :key="item.id || index">
                <div class="audit-dot" :class="getAuditDotClass(item)"></div>
                <div class="audit-line" v-if="index < timeLineList.length - 1"></div>
                <div class="audit-info">
                    <div class="audit-role">{{ getNodeRoleText(item) }}</div>
                    <template v-if="item.operators && item.operators.length > 1">
                        <div class="audit-name" v-for="(op, opIdx) in item.operators" :key="opIdx">
                            {{ op.operatorName || '-' }}
                            <span class="audit-action-tag" :class="'action-' + op.action" v-if="op.actionText">{{ op.actionText }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="audit-name">
                            {{ item.operatorName || '-' }}
                        </div>
                    </template>
                    <div class="audit-action" v-if="item.actionText && (!item.operators || item.operators.length <= 1)">
                        <span class="audit-action-tag" :class="'action-' + item.action">{{ item.actionText }}</span>
                    </div>
                    <div class="audit-comment" v-if="item.comment">
                        <span class="audit-comment-label">审批意见：</span>{{ item.comment }}
                    </div>
                    <div class="audit-time" v-if="item.operateTime">{{ item.operateTime }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ApprovalTimeline',
    props: {
        // 传入instanceId，组件内部自动请求审批详情接口
        instanceId: {
            type: [String, Number],
            default: ''
        },
        // 传入已处理好的审批列表（与instanceId二选一，list优先）
        list: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            apiTimeLineList: []
        }
    },
    computed: {
        timeLineList() {
            // list优先，否则使用接口返回的数据
            return this.list || this.apiTimeLineList
        }
    },
    watch: {
        instanceId: {
            handler(val) {
                if (val) {
                    this.fetchApprovalDetail()
                } else {
                    this.apiTimeLineList = []
                }
            },
            immediate: true
        }
    },
    methods: {
        // 请求审批详情接口
        fetchApprovalDetail() {
            if (!this.instanceId) return
            this.$Axios._get({
                url: this.$Config.apiUrl.approvalInstanceDetail,
                params: { instanceId: this.instanceId }
            }).then((res) => {
                if (res.result && res.result.code == 0) {
                    const timeLine = (res.result.data && res.result.data.timeLine) || []
                    this.apiTimeLineList = this.aggregateByLevelNum(timeLine)
                }
            }).catch((err) => {
                console.log('获取审批详情失败', err)
            })
        },
        // 按levelNum聚合审批流程，同级内按operatorId去重（保留operateTime最新的记录）
        aggregateByLevelNum(timeLine) {
            if (!timeLine || !timeLine.length) return []
            // 按levelNum分组
            const levelMap = {}
            timeLine.forEach(item => {
                const key = item.levelNum
                if (!levelMap[key]) {
                    levelMap[key] = []
                }
                levelMap[key].push(item)
            })
            // 对每级内按operatorId去重，保留operateTime最新的
            const result = []
            Object.keys(levelMap).sort((a, b) => a - b).forEach(levelNum => {
                const items = levelMap[levelNum]
                const dedupMap = {}
                items.forEach(item => {
                    const operatorId = item.operatorId || item.id
                    if (!dedupMap[operatorId]) {
                        dedupMap[operatorId] = item
                    } else {
                        // 保留operateTime最新的
                        const existing = dedupMap[operatorId]
                        if (item.operateTime && (!existing.operateTime || item.operateTime > existing.operateTime)) {
                            dedupMap[operatorId] = item
                        }
                    }
                })
                const operators = Object.values(dedupMap)
                // 取第一条记录的基础信息作为节点信息，operators为该级所有审批人
                const base = operators[0]
                result.push({
                    ...base,
                    operators: operators
                })
            })
            return result
        },
        getAuditDotClass(item) {
            if (!item.action) return 'audit-dot-pending'
            if (item.actionText && (item.actionText.includes('驳回') || item.actionText.includes('拒绝'))) {
                return 'audit-dot-reject'
            }
            return 'audit-dot-done'
        },
        getNodeRoleText(item) {
            if (item.nodeType == 1) return '发起人'
            if (item.nodeType == 2) return '审批人'
            if (item.nodeType == 3) return '抄送人'
            return '审批节点'
        }
    }
}
</script>
<style lang="scss" scoped>
.audit-flow {
    padding: 16px 0 0 0;

    &-title {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 12px;
    }

    .audit-timeline {
        position: relative;
        padding-left: 16px;

        .audit-item {
            position: relative;
            display: flex;
            flex-direction: column;
            padding-left: 20px;
            padding-bottom: 8px;

            .audit-dot {
                position: absolute;
                left: 0;
                top: 4px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: #DADDE0;
                z-index: 1;

                &-done {
                    background: #007AFF;
                }

                &-pending {
                    background: #DADDE0;
                }

                &-reject {
                    background: #F56C6C;
                }
            }

            .audit-line {
                position: absolute;
                left: 4px;
                top: 14px;
                width: 2px;
                bottom: 0;
                background: #E4E7ED;
            }

            .audit-info {
                .audit-role {
                    font-size: 13px;
                    font-weight: bold;
                    color: #303133;
                }

                .audit-name {
                    font-size: 13px;
                    color: #606266;
                    margin-top: 2px;
                }

                .audit-time {
                    font-size: 12px;
                    color: #909399;
                    margin-top: 2px;
                }

                .audit-status {
                    font-size: 12px;
                    margin-top: 2px;

                    &.status-done {
                        color: #007AFF;
                    }

                    &.status-pending {
                        color: #909399;
                    }

                    &.status-reject {
                        color: #F56C6C;
                    }
                }

                .audit-action {
                    margin-top: 4px;
                }

                .audit-action-tag {
                    display: inline-block;
                    padding: 2px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    line-height: 18px;
                    background: #E6F7FF;
                    color: #007AFF;
                    border: 1px solid #BAE7FF;
                }

                .audit-comment {
                    margin-top: 4px;
                    font-size: 12px;
                    color: #606266;
                    line-height: 18px;
                }

                .audit-comment-label {
                    color: #909399;
                }
            }
        }
    }
}
</style>
